import React from "react";

const ItemBackground = () => {
  return (
    <div className="veggieBackground">
      {/* <Box className="white-layer" /> */}
    </div>
  );
};
export default ItemBackground;
